// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-connection"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 6C11.7664 6 15.4483 6 18.0009 6C19.6578 6 21 7.34315 21 9C21 10.6569 19.6569 12 18 12H6C4.34315 12 3 13.3431 3 15C3 16.6569 4.34315 18 6 18H18M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6ZM20 18L18 19.5V16.5L20 18Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapConnectionIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-connection',
    ref,
    icon: element,
  },
));

MapConnectionIcon.displayName = 'MapConnectionIcon';

export default MapConnectionIcon;
